import React from 'react'
import { MtsPay, MtsPayCard, Spacer, Stepper, theme, Text } from '@mtsdengi/ui-kit'
import { AppBlock, CardFeature, SmartVisibleChild, SmartSpacer, unAuthTheme } from '@mtsdengi/common'
import { relocation } from '@shared/utils'
import { cardFormAuthGlobalValuesKey } from '@shared/constants'
import { TPageData } from '@shared/types'
import { Accordion } from '@entities'
import { IdentityClient } from '@widgets'
import { Styled } from './ui'

const CLIENT_ID = 'portal2-web'
const PLATFORM = 'mtsdengi.ru'
const AGREEMENT_REFERENCE_ID = 'CCApplicationWeb'

const IdentityClientProps = {
  clientId: CLIENT_ID,
  platform: PLATFORM,
  referenceId: AGREEMENT_REFERENCE_ID,
  includeFields: {
    clientFio: true,
    dateOfBirth: true,
    phoneNumber: true,
    email: true,
  },
}

export const ProcessingTab = ({
  hot2getCard,
  appBlock,
  description,
  mtspay,
  agreement,
}: Pick<TPageData, 'hot2getCard' | 'appBlock' | 'description' | 'mtspay' | 'agreement'>) => {
  const handleSMSCodeSuccess = ({
    smsCode, // Достал здесь смс код тк нет разрешения на проброс в сервис
    access_token,
    clientFio,
    ...args
  }) => {
    const [clientSurname, clientName, clientPatronymic] = clientFio.split(' ')

    window.localStorage.setItem(
      cardFormAuthGlobalValuesKey,
      JSON.stringify({ jwtToken: access_token, clientFio, ...args, clientSurname, clientName, clientPatronymic })
    )
    relocation(`/karti/fa/${new URL(window.location.href).search}`)
  }

  return (
    <>
      <Styled.Grid>
        <SmartVisibleChild conditions={{ none: 'none', tablet: 'block' }}>
          <CardFeature
            isFullHeight
            {...hot2getCard}
            heading={{
              marginBottomMob: 0,
              marginBottomTablet: 0,
              marginBottomMd: 0,
              marginBottomSm: 0,
              marginBottomUber: 0,
              marginBottomLg: 0,
              ...hot2getCard.heading,
            }}
          >
            <Spacer space={theme.spacings.xl} />
            <Stepper.StepLine isColumnsView variant="mtsDengi">
              {hot2getCard.steps.map((step) => (
                <Stepper.Step key={step.id}>
                  <Text fontWeight="medium" size="xl" font="text">
                    {step.heading}
                  </Text>
                  <Text size="lg" font="compact" color={theme.colors.neutral.g300}>
                    {step.text}
                  </Text>
                </Stepper.Step>
              ))}
            </Stepper.StepLine>
          </CardFeature>
          <SmartSpacer
            spaceTablet={unAuthTheme.spacings.md4}
            spaceMob={theme.spacings.md}
            spaceSm={theme.spacings.xl2}
          />
        </SmartVisibleChild>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <IdentityClient {...IdentityClientProps} agreement={agreement} onSubmit={handleSMSCodeSuccess} />
      </Styled.Grid>

      <SmartSpacer spaceTablet={unAuthTheme.spacings.md4} spaceMob={theme.spacings.md} spaceSm={theme.spacings.xl2} />
      {mtspay && (
        <>
          <MtsPay {...mtspay} image={<Styled.Image {...mtspay.image} />}>
            {mtspay.cards.map(({ id, ...card }) => (
              <MtsPayCard key={id} {...card} />
            ))}
          </MtsPay>
          <SmartSpacer
            spaceTablet={unAuthTheme.spacings.md4}
            spaceMob={theme.spacings.md}
            spaceSm={theme.spacings.xl2}
          />
        </>
      )}
      {appBlock && (
        <>
          <AppBlock {...appBlock} />
          <SmartSpacer
            spaceTablet={unAuthTheme.spacings.md4}
            spaceMob={theme.spacings.md}
            spaceSm={theme.spacings.xl2}
          />
        </>
      )}
      <Accordion domMounted extraLayer variant="violet" items={description} />
    </>
  )
}
